
import "./RepresentanteBanners.css";

export default function RepresentanteBanners({ banners, localizacao }) {
  if (!banners || banners.length === 0) return null;

  const bannerFood = banners.find(
    (banner) =>
      banner.localizacao === localizacao
  );

  if (!bannerFood) return null;

  return (
    <section className="representante-banner">
      <img
        src={bannerFood.imagem}
        alt="Banner promocional"
      />
    </section>
  );
}
